'use strict';

require('jquery-nice-select/js/jquery.nice-select');

const SELECTOR = 'select.nice-select-lvz:not(.sr-only)';
const LIST_MAX_HEIGHT = 280;
const EDGE_GAP = 8;
const CLIPPING_OVERFLOW_VALUES = ['auto', 'scroll', 'hidden'];

/**
 * Sticky checkout CTA height (CSS var + live sticky bar).
 * @returns {number}
 */
function getStickyCtaHeight() {
	const fromVar = Number.parseFloat(
		window.getComputedStyle(document.documentElement).getPropertyValue('--lvz-checkout-sticky-action-height')
	);
	const $stickyBar = $('.checkout-next-step-bar--sticky:visible');
	let stickyH = Number.isNaN(fromVar) ? 0 : fromVar;

	if ($stickyBar.length) {
		stickyH = Math.max(stickyH, $stickyBar.outerHeight() || 0);
	}

	return stickyH;
}

/**
 * Nearest ancestor that clips vertical overflow (e.g. a scrollable drawer region).
 * @param {HTMLElement} el
 * @returns {DOMRect|null}
 */
function getClippingRect(el) {
	let parent = el.parentElement;

	while (parent && parent !== document.body) {
		if (CLIPPING_OVERFLOW_VALUES.includes(window.getComputedStyle(parent).overflowY)) {
			return parent.getBoundingClientRect();
		}
		parent = parent.parentElement;
	}

	return null;
}

/**
 * Flip list upward when there is not enough space below (sticky CTA and clipping container counted).
 * @param {jQuery} $dropdown - .nice-select root
 */
function syncDropupPosition($dropdown) {
	if (!$dropdown || !$dropdown.length || !$dropdown.hasClass('open')) {
		if ($dropdown && $dropdown.length) {
			$dropdown.removeClass('dropup');
		}
		return;
	}

	const el = $dropdown[0];
	const $list = $dropdown.find('.list').first();
	if (!el || !$list.length) {
		return;
	}

	const rect = el.getBoundingClientRect();
	const clippingRect = getClippingRect(el);
	const viewportH = window.visualViewport ? window.visualViewport.height : window.innerHeight;
	const bottomLimit = Math.min(viewportH - getStickyCtaHeight(), clippingRect ? clippingRect.bottom : viewportH);
	const topLimit = Math.max(0, clippingRect ? clippingRect.top : 0);
	const spaceBelow = bottomLimit - rect.bottom - EDGE_GAP;
	const spaceAbove = rect.top - topLimit - EDGE_GAP;
	const listHeight = Math.min($list.outerHeight() || LIST_MAX_HEIGHT, LIST_MAX_HEIGHT);
	const shouldDropUp = spaceBelow < listHeight && spaceAbove > spaceBelow;

	$dropdown.toggleClass('dropup', shouldDropUp);
}

function clearDropup($dropdown) {
	if ($dropdown && $dropdown.length) {
		$dropdown.removeClass('dropup');
	}
}

/**
 * Copy hide-option from native <option> to nice-select <li>
 * (jquery-nice-select does not propagate option classes).
 * @param {jQuery} $select
 */
function syncHideOptions($select) {
	const $dropdown = $select.next('.nice-select');
	if (!$dropdown.length) {
		return;
	}

	$select.find('option').each(function (i) {
		$dropdown.find('.list > li').eq(i).toggleClass('hide-option', $(this).hasClass('hide-option'));
	});
}

function refresh($context) {
	($context || $(document)).find(SELECTOR).each(function () {
		const $el = $(this);
		if ($el.next('.nice-select').length) {
			$el.niceSelect('update');
		} else {
			$el.niceSelect();
		}
		syncHideOptions($el);
	});
}

module.exports = function () {
	refresh();

	$(document).on('update:nice-select', function (_e, data) {
		refresh(data && data.$context);
	});

	$('body').on('checkout:updateCheckoutView shipping:updateShippingAddressSelector', function () {
		$(document).trigger('update:nice-select', { $context: $('#checkout-main') });
	});

	// After jquery-nice-select toggles `.open`, decide dropup vs dropdown.
	$(document).on('click.niceSelectDropup', '.nice-select.nice-select-lvz', function () {
		const $dropdown = $(this);
		window.requestAnimationFrame(function () {
			if ($dropdown.hasClass('open')) {
				syncDropupPosition($dropdown);
			} else {
				clearDropup($dropdown);
			}
		});
	});

	$(document).on('click.niceSelectDropupOutside', function (event) {
		if ($(event.target).closest('.nice-select').length === 0) {
			$('.nice-select.nice-select-lvz.dropup').removeClass('dropup');
		}
	});

	$(window).on('resize.niceSelectDropup orientationchange.niceSelectDropup', function () {
		const $open = $('.nice-select.nice-select-lvz.open');
		if ($open.length) {
			syncDropupPosition($open);
		}
	});
};
